module.exports = __webpack_public_path__ + "static/media/settlement_logo.605c1732.png";